<template>
	<div
		class="am-input-textarea"
		:class="[
			{
				'is-focused': focused
			}
		]"
		>

		<textarea
			class="am-input-textarea__field"
			:value="value"
			:placeholder="label"
			@input="$emit('input', $event.target.value)"
			@focus="focused = true"
			@blur="focused = false"
			@keydown="$emit('keydown', $event)"
			@keyup="$emit('keyup', $event)"
		>
		</textarea>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			default: null
		},
		label: {
			type: String,
			default: 'Hello World'
		}
	},

	data: () => ({
		focused: false
	})
}
</script>

<style lang="scss">
.am-input-textarea{
	width: 100%;
	position: relative;
	&__field{
		width: 100%;
		display: block;
		min-height: 172px;
		border: 0;
		background: white;
		font-size: 16px;
		box-sizing: border-box;
		outline: none;
		border-radius: 29px;
		padding: 24px 32px;
		color: $c-light-brown;
		transition: .3s $easeInOutQuad;
		font-family: Flama;
		font-size: 16px;
		color: $c-brown;
		resize: none;
		&::placeholder{
			font-size: 12px;
			transform: translateY(3px);
		}
		&:-webkit-autofill{
			-webkit-box-shadow: 0 0 0px 1000px white inset;	
		}
	}

	&.is-focused{
		.am-input-textarea{
			&__field{
				box-shadow: 0 8px 15px rgba(black, .07);
			}
		}
	}
}

</style>
